import { DefaultButton, Dropdown, Icon } from "@fluentui/react";
import React, { useEffect, useState } from "react";

const Pagination = (props) => {
  const rowsPerPage = [
    {
      key: 5,
      text: 5,
    },
    {
      key: 10,
      text: 10,
    },
    {
      key: 15,
      text: 15,
    },
  ];
  const handleDropDownClick = (e) => {
    props.setPageNumber(1);
    props.setselectedRowsPerPage(+e.currentTarget.childNodes[0].innerText);
  };

  const [pageCount, setPageCount] = useState([]);

  useEffect(() => {
    if (Math.ceil(props.length / props.selectedRowsPerPage) == 1) {
      setPageCount([1]);
    }
    if (Math.ceil(props.length / props.selectedRowsPerPage) == 2){
      setPageCount([1, 2]);
    }
    if (Math.ceil(props.length / props.selectedRowsPerPage) > 2) {
      if (props.pageNumber === 1) {
        setPageCount([1, 2, 3]);
      } else if (
        Math.ceil(props.length / props.selectedRowsPerPage) != props.pageNumber
      ) {
        setPageCount([
          props.pageNumber - 1,
          props.pageNumber,
          props.pageNumber + 1,
        ]);
      } else if (
        Math.ceil(props.length / props.selectedRowsPerPage) == props.pageNumber
      ) {
        setPageCount([
          props.pageNumber - 2,
          props.pageNumber - 1,
          props.pageNumber,
        ]);
      }
    }
  }, [props.length, props.pageNumber, props.selectedRowsPerPage]);

  return (
    <>
      <div className="pagination">
        <div className="pagination-rowCount">
          <p>Rows per page: </p>
          <Dropdown
            selectedKey={props.selectedRowsPerPage}
            options={rowsPerPage}
            onChange={(e) => handleDropDownClick(e)}
          />
        </div>
        <div className="pagination-pageCount">
          <p className="pagination-pageCountElement">
            {(props.pageNumber - 1) * props.selectedRowsPerPage + 1}-
            {props.pageNumber !=
            Math.ceil(props.length / props.selectedRowsPerPage)
              ? (props.pageNumber - 1) * props.selectedRowsPerPage +
                props.selectedRowsPerPage
              : props.length}{" "}
            of {props.length} entries
          </p>
          <Icon
            iconName="ChevronLeft"
            className={`pagination-pageCountElement ${
              props.pageNumber === 1 ? "pagination-disabled" : ""
            }`}
            onClick={() => props.setPageNumber(props.pageNumber - 1)}
          ></Icon>
          {pageCount.map((page, index) => {
            return (
              <DefaultButton
                key={index}
                className={`pagination-button pagination-pageCountElement ${
                  props.pageNumber === page ? "pagination-selected" : ""
                }`}
                text={page}
                onClick={() => props.setPageNumber(page)}
              />
            );
          })}
          <Icon
            iconName="ChevronRight"
            className={`pagination-pageCountElement ${
              props.pageNumber ===
              Math.ceil(props.length / props.selectedRowsPerPage)
                ? "pagination-disabled"
                : ""
            }`}
            onClick={() => props.setPageNumber(props.pageNumber + 1)}
          ></Icon>
        </div>
      </div>
    </>
  );
};

export default Pagination;
